import {
  DashboardModuleListItem, Image, SidebarModal,
} from '@domain-group/suit-theme'

import useProvider from '@hooks/useProvider'

import placeholderImageUrl from './assets/placeholder.svg'

interface ProviderSubHeaderProps {
  providerId: number,
  secondaryText: string,
}

const ProviderSubHeader = (props: ProviderSubHeaderProps) => {
  const { providerId, secondaryText } = props

  const { alternateLogoUrl, provider: { title } } = useProvider({ id: providerId })

  if (!title) return null

  return (
    <SidebarModal.SubHeader>
      <DashboardModuleListItem
        boxProps={{ padding: 'none' }}
        isSidebar
        imageComponent={(
          <Image
            backgroundSize="cover"
            borderRadius={5}
            boxProps={{ border: '1px solid', borderColor: 'lineColor' }}
            height={38}
            // @ts-expect-error TS2322
            place
            placeholderUrl={placeholderImageUrl}
            url={alternateLogoUrl}
            width={60}
          />
        )}
        secondaryText={secondaryText}
        title={title}
      />
    </SidebarModal.SubHeader>
  )
}

export default ProviderSubHeader
